/* HoneMD treatment-grid goal filter.
   Markup contract:
     [data-hm-filter]
       [data-hm-chip][data-goal="key"]      (desktop chips + mobile sheet options)
       [data-hm-card][data-goals="a b c"]    (treatment cards; space-separated goal keys)
       [data-hm-filter-toggle]               (mobile "FILTERS" button, optional)
       [data-hm-filter-sheet]                (mobile panel, optional)
       [data-hm-filter-clear]                (clear button, optional)
       [data-hm-filter-label]                (text node reflecting active filter, optional) */
(function () {
  function setup(root) {
    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-hm-chip]'));
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-hm-card]'));
    var sheet = root.querySelector('[data-hm-filter-sheet]');
    var toggle = root.querySelector('[data-hm-filter-toggle]');
    var clear = root.querySelector('[data-hm-filter-clear]');
    var label = root.querySelector('[data-hm-filter-label]');

    function apply(goal) {
      cards.forEach(function (card) {
        var goals = (card.getAttribute('data-goals') || '').split(/\s+/);
        var show = goal === 'all' || goals.indexOf(goal) !== -1;
        card.hidden = !show;
      });
      chips.forEach(function (c) {
        var active = c.getAttribute('data-goal') === goal;
        c.classList.toggle('is-active', active);
        c.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      if (label) {
        var active = chips.filter(function (c) { return c.getAttribute('data-goal') === goal; })[0];
        label.textContent = active ? active.textContent.trim() : 'All';
      }
      // Card visibility changed - let carousels recalc their progress/arrows.
      window.dispatchEvent(new Event('resize'));
    }

    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        apply(c.getAttribute('data-goal'));
        if (sheet) sheet.classList.remove('is-open');
      });
    });
    if (toggle && sheet) toggle.addEventListener('click', function () { sheet.classList.toggle('is-open'); });
    if (clear) clear.addEventListener('click', function () { apply('all'); if (sheet) sheet.classList.remove('is-open'); });

    apply('all');
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-hm-filter]').forEach(setup);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
